import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {AppService} from "../../app.service";
import {ApiRequestService} from "../api-request.service";
import {UtilsService} from "../utils.service";
import {tap} from "rxjs/operators";
import {ApiDataSource} from "../../utils/api-data-source";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {SitesSelectorComponent} from "../sites-selector/sites-selector.component";

@Component({
  selector: 'app-account-sites-hazards-selector',
  templateUrl: './account-sites-hazards-selector.component.html',
  styleUrls: ['./account-sites-hazards-selector.component.scss']
})
export class AccountSitesHazardsSelectorComponent implements OnInit {

  // columns to show and the data source
  displayedColumns: string[] = ['select', 'name', 'status', 'ira', 'rra', 'site'];

  site_id: number;

  dataSource: AccountSitesHazardsSelectorDataSource;
  returnAllSelected = false;

  // the paginator and sorter
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    public app: AppService,
    private api: ApiRequestService,
    public utils: UtilsService,
    public dialogRef: MatDialogRef<AccountSitesHazardsSelectorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // set multiple if it is not present to false
    if (typeof this.data['multiple'] === 'undefined') {
      this.data['multiple'] = false;
    }

    // construct the datasource
    this.dataSource = new AccountSitesHazardsSelectorDataSource(
      this.app,
      this.api,
      this.data['multiple']
    );

    // set a default selection of nothing if no selected values are passed through
    if (typeof this.data['selected'] === 'undefined') {
      this.data['selected'] = [];
    }

    // loop and select the values
    for (let i = 0; i < this.data['selected'].length; i++) {
      if (this.data['selected'][i]) {
        this.dataSource.selection.select(this.data['selected'][i]);
      }
    }

    if (typeof this.data['site_id'] !== 'undefined') {
      this.dataSource.site_id = this.data['site_id'];
    }

    // get the list of sites
    this.dataSource.getData();
  }

  ngOnInit() {}

  ngAfterViewInit() {
    // reset the paginator when sorting
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

    const _tap = tap(() => {
      this.dataSource.limit = this.paginator.pageSize;
      this.dataSource.offset = this.paginator.pageIndex;
      this.dataSource.sort_by = this.sort.active;
      this.dataSource.sort_order = this.sort.direction;

      this.dataSource.getData();
    });

    // subscribe to the paginator tap events
    this.paginator.page.pipe(_tap).subscribe();
    this.sort.sortChange.pipe(_tap).subscribe();
  }

  // clears the search bar and performs a search
  onClearSearch() {
    // clear the search field in the datasource
    this.dataSource.search = '';
    // search for records
    this.dataSource.getData(true);
  }

  onClearSelected() {
    this.dataSource.selection.clear();
  }

  /**
   * before the dialog close we want to store the new active site id
   */
  onSaveAndClose() {
    let response: number | number[];

    if (this.data['multiple']) {
      response = this.dataSource.selection.selected;
    } else {
      if (this.dataSource.selection.selected.length) {
        response = this.dataSource.selection.selected[0];
      } else {
        response = 0;
      }
    }

    this.dialogRef.close(response);
  }

  onChangeSelectedSite() {
    this.utils.showComponentDialog(
      SitesSelectorComponent,
      {
        selected: [this.dataSource.site_id],
        multiple: false,
        allow_no_selection: true
      },
      {
        width: '1200px'
      },
      (selectedId: number) => {
        if (typeof selectedId !== 'undefined') {
          this.dataSource.site_id = selectedId;
          this.dataSource.getData(true);
        }
      }
    );
  }

  onClose() {
    this.dialogRef.close();
  }

  /**
   * Retrieves the site information from the provided hazard object.
   *
   * @param {any} hazard - The hazard object containing site information.
   * @return {any|null} The site information from the hazard object, or null if not found.
   */
  getHazardSite(hazard: any): any | null {
    return hazard.site || hazard.asset?.site || null;
  }

}

export class AccountSitesHazardsSelectorDataSource extends ApiDataSource {
  // record sorting and direction
  sort_by = 'name';
  sort_order = 'asc';

  archived = 'false';
  site_id: number = 0;

  getData(resetOffset: boolean = false) {
    this.makeRequest('v1/sites/' + this.site_id + '/hazards', resetOffset, {
      archived: this.archived
    });
  }
}
